import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"margin":"0"} }, " Новый заказ-наряд ")
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  style: {"display":"flex"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"margin":"0"} }, " Заказ-наряд ")
], -1)
const _hoisted_8 = {
  key: 1,
  class: "highlighted-placeholder"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  class: "base-form form",
  style: {"margin-left":"0"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "recomendations go here", -1)
const _hoisted_12 = { class: "base-form form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_editable_component = _resolveComponent("text-editable-component")!
  const _component_order_print_form_component = _resolveComponent("order-print-form-component")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_order_common_form_component = _resolveComponent("order-common-form-component")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_order_jobs_component = _resolveComponent("order-jobs-component")!
  const _component_order_items_component = _resolveComponent("order-items-component")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_button_loading_component = _resolveComponent("button-loading-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 24 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.isCreatingMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  (_ctx.ruleForm.applyManualOrderNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_text_editable_component, {
                          modelValue: _ctx.ruleForm.orderNumber,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.orderNumber) = $event)),
                          class: "highlighted-placeholder colored-font"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    innerHTML: _ctx.renderTotalCost()
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isCreatingMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  (_ctx.ruleForm.applyManualOrderNumber)
                    ? (_openBlock(), _createBlock(_component_text_editable_component, {
                        key: 0,
                        modelValue: _ctx.ruleForm.orderNumber,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.orderNumber) = $event)),
                        class: "highlighted-placeholder colored-font"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  (!_ctx.ruleForm.applyManualOrderNumber && _ctx.ruleForm.orderNumber?.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.ruleForm.orderNumber), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    innerHTML: _ctx.renderTotalCost()
                  }, null, 8, _hoisted_9),
                  _createVNode(_component_order_print_form_component, {
                    "order-id": _ctx.ruleForm.id,
                    "icon-only": ""
                  }, null, 8, ["order-id"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            class: "order-tabs",
            modelValue: _ctx.orderActiveTab,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.orderActiveTab) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "Основное",
                name: "common"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_order_common_form_component, {
                      ref: "commonFormComponent",
                      modelValue: _ctx.ruleForm.common,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.common) = $event)),
                      order: _ctx.existingOrder,
                      executives: _ctx.executiveEntities,
                      "creating-mode": _ctx.isCreatingMode
                    }, null, 8, ["modelValue", "order", "executives", "creating-mode"]),
                    _createVNode(_component_el_form, {
                      ref: "form",
                      rules: _ctx.rules,
                      model: _ctx.ruleForm
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          "label-position": "top",
                          prop: "orderNumber"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_switch, {
                              modelValue: _ctx.ruleForm.applyManualOrderNumber,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.applyManualOrderNumber) = $event)),
                              onChange: _ctx.onApplyManualOrderNumberChange,
                              "active-text": _ctx.isCreatingMode ? 'Ручной ввод номера ЗН' : 'Разрешить изменение номера ЗН'
                            }, null, 8, ["modelValue", "onChange", "active-text"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["rules", "model"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: `Работы ${_ctx.ruleForm?.jobs?.length ? `(${_ctx.ruleForm.jobs.length})` : ''}`,
                name: "jobs"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_order_jobs_component, {
                      ref: "jobsForm",
                      jobs: _ctx.ruleForm.jobs,
                      "onUpdate:jobs": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.jobs) = $event)),
                      order: _ctx.orderMock
                    }, null, 8, ["jobs", "order"])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_tab_pane, {
                label: `Запчасти ${_ctx.ruleForm?.orderItems?.length ? `(${_ctx.ruleForm.orderItems.length})` : ''}`,
                name: "items"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_order_items_component, {
                      ref: "itemsForm",
                      items: _ctx.ruleForm.orderItems,
                      "onUpdate:items": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.orderItems) = $event)),
                      itemDemands: _ctx.ruleForm.orderItemDemands,
                      "onUpdate:itemDemands": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.orderItemDemands) = $event))
                    }, null, 8, ["items", "itemDemands"])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_tab_pane, {
                label: "Рекомендации",
                name: "recs"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.isCreatingMode)
                  ? (_openBlock(), _createBlock(_component_button_loading_component, {
                      key: 0,
                      label: "Создать заказ-наряд",
                      onClick: _ctx.onCreateOrderClick
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_button_loading_component, {
                      key: 1,
                      label: "Сохранить изменения",
                      onClick: _ctx.onUpdateOrderClick
                    }, null, 8, ["onClick"])),
                _createVNode(_component_el_button, {
                  onClick: _ctx.resetForm,
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Отменить изменения ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.isAsyncOperationPending]
      ])
    ]),
    _: 1
  }))
}